
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_URL } from "common/constants/sm-constants";
import { EncryptionAndDecryption } from "./encrypt-decrypt.service";
import { map } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({ providedIn: "root" })
export class LogoutService {



    constructor(private http: HttpClient) { }

    logout(): Promise<any> {
        return new Promise((resolve, reject) => {
          const paramUrl = environment.apiUrl + API_URL.logout;
          const profile = JSON.parse(localStorage.getItem('loginData') || '{}');
          const payload = {
            id: profile.id,
            api_access_tokon: profile.api_access_tokon
          };
      
          this.http
            .post<any>(paramUrl, { details: EncryptionAndDecryption.encryption(payload) })
            .pipe(
              map(response => {
                if (response?.details) {
                  const decrypted = EncryptionAndDecryption.decryption(response.details);
                  return { ...response, details: decrypted };
                }
                return response;
              })
            )
            .toPromise()
            .then((res) => {
              resolve(res); 
            })
            .catch((err) => {
              reject(err);
            });
        });
      }
      

}

